import { AwesomeGraphQLClient } from 'awesome-graphql-client';
import { requestIdHeader } from '../requestId';
export { gql } from 'awesome-graphql-client';
export class GraphQLClient {
    static instance = null;
    constructor() { }
    static init(url, getToken) {
        GraphQLClient.instance = new AwesomeGraphQLClient({
            endpoint: url,
            fetch: async (input, init) => {
                let resultInput = input;
                if (typeof input === 'string' && typeof init?.body === 'string') {
                    const operationInfo = typeof init?.body === 'string' ? init.body.match(/(query|mutation)\s+(\w+)/) : undefined;
                    if (operationInfo?.length === 3) {
                        resultInput = `${input}?${operationInfo[1]}=${operationInfo[2]}`;
                    }
                }
                const token = await getToken();
                return fetch(resultInput, {
                    ...init,
                    headers: {
                        ...init?.headers,
                        ...requestIdHeader(),
                        Authorization: `Bearer ${token}`,
                        'Apollo-Require-Preflight': 'true',
                        'apollo-require-preflight': 'true',
                    },
                });
            },
        });
    }
    static getInstance() {
        if (GraphQLClient.instance === null) {
            throw new Error('GraphQL client is not initialized');
        }
        return GraphQLClient.instance;
    }
    static async requestWithHeaders(query, variables) {
        const instance = GraphQLClient.getInstance();
        const result = await instance.requestSafe(query, variables);
        if (!result.ok) {
            throw new Error('GraphQL request failed');
        }
        return {
            data: result.data,
            headers: result.response.headers,
        };
    }
}
//# sourceMappingURL=graphql.js.map